import { object } from 'yup';
import {
  address,
  common,
  company,
  email,
  fax,
  name,
  phone,
  requiredField,
  zipcode,
} from '../../../helpers/yupConstants';

export const API_ROUTES = {
  CUSTOMER_INFO: {
    METHOD: 'GET',
    URL: 'customer',
  },
  CUSTOMER_LIST: {
    METHOD: 'POST',
    URL: 'customer/list',
  },
  CUSTOMER_ADD: {
    METHOD: 'POST',
    URL: 'customer/add',
  },
  CHANGE_STATUS: {
    METHOD: 'PUT',
    URL: 'status',
  },
  CUSTOMER_UPDATE: {
    METHOD: 'PUT',
    URL: 'customer',
  },
  CUSTOMER_DELETE: {
    METHOD: 'DELETE',
    URL: 'customer',
  },
};

export const addCustomerInitialValues = {
  name: '',
  company: '',
  trade_name: '',
  email: '',
  phone: '',
  password: '',
  type: 'commercial',
  website: '',
  joined_at: null,
  ratecard_id: '',
  sms_ratecard_id: '',
  billing_date: null,
  address1: '',
  address2: '',
  city: '',
  country: 'GB',
  zip: '',
  fax: '',
};

export const addCustomerSchema = object({
  name: name({ fieldName: 'name' }),
  company: company({ fieldName: 'comapny name', isRequired: false }),
  trade_name: name({ fieldName: 'Trade name', isRequired: false }),
  email: email({ fieldName: 'email' }),
  phone: phone({ fieldName: 'phone' }),
  // password: password({ fieldName: 'password' }),
  type: requiredField({ fieldName: 'type' }),
  website: common({ fieldName: 'website', isRequired: false }),
  // url: common({ fieldName: 'URL', isRequired: false }),
  joined_at: requiredField({ fieldName: 'joined date' }),
  ratecard_id: requiredField({ fieldName: 'call rate card' }),
  sms_ratecard_id: requiredField({ fieldName: 'SMS rate card' }),
  // activation_date: requiredField({ fieldName: 'activation date' }),
  billing_date: requiredField({ fieldName: 'billing date' }),
  address1: address({ fieldName: 'address 1' }),
  address2: address({ fieldName: 'address 2', isRequired: false }),
  city: common({ fieldName: 'city' }),
  country: requiredField({ fieldName: 'country' }),
  zip: zipcode({ fieldName: 'pincode' }),
  fax: fax({ fieldName: 'fax', isRequired: false }),
});

export const tabsArray = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: 'Active',
    value: 'active',
  },
  {
    label: 'Resellers',
    value: 'resellers',
  },
  {
    label: 'Multi Site',
    value: 'multi-site',
  },
  {
    label: 'Suspended',
    value: 'suspended',
  },
  {
    label: 'Direct Debit',
    value: 'direct-debit',
  },
  {
    label: 'Non-VAT',
    value: 'non-vat',
  },
];

export const sliderTitle = {
  view: 'View Package',
  suspend: 'Suspend Package',
  'assign-site': 'Assign Other Site',
  'replace-package': 'Replace Package',
  activate: 'Activate Package',
};
